angular.module('rjmNg.directives').directive "metricFormula", [
  () ->
    restrict: 'E'
    templateUrl: "directive.metricFormula.html"
    replace: true
    controllerAs: "view"
    bindToController: true
    scope:
      currencies: "="
      metric: "="
      selectedMetrics: "="
    controller: [
      "$scope"
      "app"
      "encodedLetterString"
      "FORMULA_EXPRESSION_CHARACTER_LIMIT"
      "metricDataTypes"
      "rjqlFormula"
      (
        $scope
        app
        encodedLetterString
        FORMULA_EXPRESSION_CHARACTER_LIMIT
        metricDataTypes
        rjqlFormula
      ) ->
        view = @

        RJQL_VERSION = app.getRjqlVersion()
        DATA_TYPE_CONSTANTS = metricDataTypes.DATA_TYPES
        DEFAULT_CURRENCY = app.getClientDefaultCurrency().code

        view.CURRENCY_DATA_TYPE = DATA_TYPE_CONSTANTS.currency

        view.canUseAdditionalSymbols = RJQL_VERSION is 1.0
        view.numToLetterString = encodedLetterString.numToLetter

        view.dataTypes = [
          name: DATA_TYPE_CONSTANTS.nonMonetary
          label: '<strong>123</strong> Number'
        ,
          name: DATA_TYPE_CONSTANTS.percentage
          label: '<span class="rj-icon--percent"></span> Percent'
        ,
          name: DATA_TYPE_CONSTANTS.currency
          label: '<span class="rj-icon--money-bill"></span> Currency'
        ,
          name: DATA_TYPE_CONSTANTS.seconds
          label: '<span class="rj-icon--clock"></span> Time'
        ,
          name: DATA_TYPE_CONSTANTS.bytes
          label: '<span class="rj-icon--hdd"></span> Bytes'
        ]

        _getFullLabel = () ->
          for dataType in view.dataTypes
            if dataType.name is view.metric?.assignedType?.type
              return dataType.label
          return null

        _updateCurrentDataTypeLabel = () ->
          view.currentDataTypeLabel = _getFullLabel()

        # See if this metric has a working expression
        _evaluateFormula = (selectedMetric) ->
          view.errorString = rjqlFormula.applyFormula(view.selectedMetrics, selectedMetric, RJQL_VERSION)

        view.firstDefultCurrency = (currency) ->
          return if currency.code is DEFAULT_CURRENCY then 0 else 1

        view.setDatatype = (dataType) ->
          view.metric?.assignedType?.type = dataType
          _updateCurrentDataTypeLabel()
          return

        view.setCurrencyCode = (currencyCode) ->
          view.metric?.assignedType?.currencyCode = currencyCode
          return

        $scope.$watch "view.metric.expressionText", () ->
          # limit the number of chars a user can enter--
          # this prevents errors caused by trying to parse a too-long
          # expression on the back end
          if view.metric?.expressionText?.length > FORMULA_EXPRESSION_CHARACTER_LIMIT
            view.errorString = "Formula expression is too long (#{FORMULA_EXPRESSION_CHARACTER_LIMIT} character limit)"
            view.metric.valid = false
          # Watch to see if the expression changes and then update the expression object
          else if view.metric?.expressionText?
            _evaluateFormula(view.metric)

        $scope.$watch "view.metric.assignedType.type", () ->
          _updateCurrentDataTypeLabel()

        view.$postLink = () ->
          _updateCurrentDataTypeLabel()

        return view
    ]
]
